import { CheckCircleIcon } from "@heroicons/react/24/solid";

export default function ProductIncluded() {
    return (
        <div className="flex justify-center">
            <CheckCircleIcon className="h-5 w-5 text-emerald-600" />
        </div>
    );
}
